import React from 'react'
import {CircularProgress, Stack, Typography} from "@mui/material"
import {Navigate} from "react-router-dom"
import {withAuthenticationRequired} from "@auth0/auth0-react"

function LoginPage() {
    return <Navigate to="/organizations/select" replace/>
}

export default withAuthenticationRequired(LoginPage, {
    loginOptions: {
        appState: {returnTo: "/onboarding/user"},
        authorizationParams: {screen_hint: "signup"},
    },
    onRedirecting: () => (
        <Stack alignItems="center" justifyContent="center" spacing={3} sx={{minHeight: "70vh"}}>
            <CircularProgress size={36} thickness={3.5}/>
            <Typography color="text.secondary" sx={{fontSize: "0.9rem", letterSpacing: "0.02em"}}>
                Just a moment…
            </Typography>
        </Stack>
    ),
})
